export default __webpack_public_path__ + "static/media/thyroid.5490dbcc.jpg";